/*-----------------------------------------------------------------
- Auth
-----------------------------------------------------------------*/
export default {
    title: 'به سایت بانمک خوش آمدید',

    login: {
        title      : 'ورود به پنل کاربری سایت',
        subtitle   : 'با شماره موبایل خود وارد سایت شوید و سفارش خود را ثبت کنید',
        description: {
            text: 'حساب کاربری ندارید؟',
            link: 'یک حساب کاربری بسازید.',
        },
        button     : 'ورود',
        remember_me: 'مرا به خاطر بسپار',
    },

    register: {
        title      : 'حساب کاربری بسازید',
        subtitle   : 'درسایت ثبت‌نام کنید و وارد سایت شوید و سفارش خود را ثبت کنید',
        description: {
            text: 'حساب کاربری دارید؟',
            link: 'وارد شوید.',
        },
        button: 'ثبت نام',
    },

    forget: {
        subtitle: 'جهت بازیابی رمز‌عبور ایمیل یا شماره تماس خود را وارد کنید',
        titles  : {
            forget_request: 'درخواست بازیابی رمز عبور',
            verify_token  : 'تایید کد بازنشانی رمز عبور',
            reset_password: 'تغییر رمز عبور',
        },
        descriptions: {
            forget_request: 'لطفا شماره موبایل یا ایمیل خود را وارد کنید.',
            verify_token  : 'کد ارسال شده به {username} را وارد کنید.',
            reset_password: '',
        },
        token: {
            text  : 'کد را دریافت نکردید؟',
            resend: 'ارسال مجدد کد ',
        },
        link   : 'رمز عبور خود را فراموش کرده‌اید؟',
        buttons: {
            edit_username : 'ویرایش',
            send_code     : 'ارسال کد تایید',
            confirm       : 'تایید',
            reset_password: 'تغییر رمز عبور',
        },
        messages: {
            success_reset: 'رمز عبور با موفقیت تغییر کرد.',
        },
    },
};
